import { __assign } from "tslib";
import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Tooltip } from '@keen.io/ui-core';
import { TOOLTIP_MOTION } from '../../../../constants';
export var MetricTooltip = function (_a) {
    var tooltipPosition = _a.tooltipPosition, tooltipSettings = _a.tooltipSettings, children = _a.children;
    return (React.createElement(AnimatePresence, null,
        React.createElement(motion.div, __assign({}, TOOLTIP_MOTION, { initial: {
                opacity: 0,
                x: tooltipPosition.x,
                y: tooltipPosition.y,
                top: 0,
                left: 0,
            }, animate: {
                x: tooltipPosition.x,
                y: tooltipPosition.y,
                opacity: 1,
            }, style: {
                position: 'fixed',
                pointerEvents: 'none',
            } }),
            React.createElement(Tooltip, { mode: tooltipSettings.mode, hasArrow: false }, children))));
};
